import React from 'react'
import "../../styles/ApprovalHeader.css"
import CommonNavbar from '../../Navbar/CommonNavbar'

const ApprovalHeader = ({ onSearch, disableSearch = false }) => {
  return (
    <div>
      <header>
        <nav className="nav-items" >
          <p className='approval-config-p' style={{ fontSize: "14px" }}>Approval Configuration</p>

          <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />

        </nav>
      </header>
    </div>
  )
}

export default ApprovalHeader